/** @jsx jsx */
import BsContainer from 'react-bootstrap/Container';
import { jsx, Box } from 'theme-ui';
import { Container as styles } from './Grid.styles';

export default function StyledContainer(props) {
  return (
    <Box
      as={BsContainer}
      {...props}
      sx={theme => ({
        maxWidth: theme.sizes && theme.sizes.container, // Arrays don't work for sizes, so we have to add them manually.
        ...styles,
      })}
    />
  );
}
